// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2NstB","title":"ClientInsurance_title__1L8uV","itemText":"ClientInsurance_itemText__2PwHn"};